import { isPositiveNumber, reduce } from "et3-type-guards";
import getReportsStore from ".";
import { apiCallGetReportsByType } from "../../api/report-api/api-call-get-reports-by-type";
import getCoreUIStore from "../core/core-ui-store";
import { parseConversationData } from "../../helpers/et3-conversation-parse";
import getCorePopUpStore from "../core/core-popup-store";
import { reducerToZeroIfUndefined } from "../../helpers/et3-picker-data-helper";

export const getReportsByType = async () => {
  const reportsStore = getReportsStore();
  const definedLimit = reducerToZeroIfUndefined(
    parseInt(reportsStore.reportsByTypeLimit.get().value, 10)
  );

  if (!isPositiveNumber(definedLimit)) {
    return;
  }

  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallGetReportsByType({
    reportStatus: reportsStore.status.get().value,
    dateMin: reportsStore.fromDate.get(),
    dateMax: reportsStore.toDate.get(),
    limit: definedLimit,
    order: reportsStore.order.get().value,
    createdFromType: getReportsStore().createdFromType.get().value
  });
  const databaseReports = reduce(() => data.reports, []);
  const reports = databaseReports.map((report) => {
    report.conversation = parseConversationData(report.conversation);
    return report;
  });
  if (status === "OK") {
    getReportsStore().setReportsByType(reports);
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
  getCoreUIStore().setIsLoading("REPORTS", false);
};
